<template>
    <div>
        <div v-for="status in statuses">
            <checkbox
                v-if="status.id !== 3"
                :checked="filter.statuses.includes(status.id)"
                @change="updateStatuses(status.id, $event)"
            >
                <div class="flex items-center gap-4">
                    <svg-icon class="w-18 h-18" :class="'fill-' + status.color" :type="status.icon" />
                    <div>
                        <span>{{ status.name }}</span>
                    </div>
                </div>
            </checkbox>
        </div>
    </div>
</template>

<script>
import * as interviewService from '../../services/InterviewService';
import InterviewStatus from "../../models/InterviewStatus";
import Checkbox from "../forms/Checkbox.vue";
import SvgIcon from "../ui/SvgIcon.vue";
import {useRepo} from 'pinia-orm';

export default {
    name: 'FilterStatus',
    components: {SvgIcon, Checkbox},
    props: {
        filter: Object
    },
    data() {
        return {
            fetchingStatuses: false,
        };
    },
    computed: {
        statuses() {
            return useRepo(InterviewStatus).all();
        },
    },
    methods: {
        fetchStatuses() {
            this.fetchingStatuses = true;

            interviewService.statuses()
                .then((response) => {
                    return useRepo(InterviewStatus).save(response);
                })
                .then(() => {
                    this.fetchingStatuses = false;
                });
        },
        updateStatuses(id, value) {
            if (value) {
                this.filter.statuses.push(id);
            } else {
                this.filter.statuses = this.filter.statuses.filter((status) => status !== id);
            }
        }
    },
    mounted() {
        this.fetchStatuses();
    }
}
</script>
